import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { error } from '../../../../../../../../../ErrorHandling';
import { TPlainTextKey } from '../../../../../../../../../Translations';
import ModalStore from '../../../../../../../../Modal/Store';
import {
  GroupParticipantsResource,
  ParticipantResource,
} from '../../../../../../GroupParticipantsStore/Types';
import { State, deleted, deleting, ready, success, waiting } from './Types';

class RemoveParticipantStore {
  @observable
  state: State = waiting();

  readonly modalStore = new ModalStore();

  constructor() {
    makeObservable(this);
  }

  @action
  ready = (participant: ParticipantResource, groupResource: GroupParticipantsResource) => {
    switch (this.state.kind) {
      case 'waiting':
        this.state = ready(participant, groupResource);
        break;
      case 'deleting':
      case 'deleted':
      case 'failure':
      case 'success':
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  deleting = (participant: ParticipantResource, groupResource: GroupParticipantsResource) => {
    switch (this.state.kind) {
      case 'ready':
        this.state = deleting(participant, groupResource);
        break;
      case 'deleted':
      case 'waiting':
      case 'deleting':
      case 'failure':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  success = () => {
    switch (this.state.kind) {
      case 'deleting':
        this.state = success(this.state.participant, this.state.groupResource);
        break;
      case 'deleted':
      case 'ready':
      case 'waiting':
      case 'failure':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => (this.state = error(msg));

  @action
  closeModal = () => {
    switch (this.state.kind) {
      case 'deleted':
      case 'success':
        this.state = deleted(this.state.participant);
        break;
      case 'ready':
      case 'deleting':
      case 'waiting':
      case 'failure':
      case 'error':
        this.state = waiting();
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default RemoveParticipantStore;
